export default "__VITE_ASSET__0eGLGI7i__"